var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('drafts',{attrs:{"items":_vm.edits,"loading":_vm.loading,"count":_vm.count,"page-size":_vm.pageSize},on:{"filter-changed":_vm.onFilterChanged,"search":_vm.editSearch,"pageChange":_vm.onPageChange,"refresh":_vm.onRefresh}})}
var staticRenderFns = []

export { render, staticRenderFns }